import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CongresVirtuelMainComponent } from './congres-virtuel-main/congres-virtuel-main.component';
import { CvmHeaderComponent } from './cvm-header/cvm-header.component';
import { CvmFooterComponent } from './cvm-footer/cvm-footer.component';
import { CvmLoginBoxComponent } from './cvm-login-box/cvm-login-box.component';
import { CongresVirtuelVideoComponent } from './congres-virtuel-video/congres-virtuel-video.component';
import { CongresVirtuelMotpresidentComponent } from './congres-virtuel-motpresident/congres-virtuel-motpresident.component';
import { CongresVirtuelAproposComponent } from './congres-virtuel-apropos/congres-virtuel-apropos.component';
import { CongresVirtuelAccreditationComponent } from './congres-virtuel-accreditation/congres-virtuel-accreditation.component';
import { CongresVirtuelComitesComponent } from './congres-virtuel-comites/congres-virtuel-comites.component';
import { CongresVirtuelAuthComponent } from './congres-virtuel-auth/congres-virtuel-auth.component';
import { CongresVirtuelProgrammeComponent } from './congres-virtuel-programme/congres-virtuel-programme.component';
import { CongresVirtuelChangePassComponent } from './congres-virtuel-change-pass/congres-virtuel-change-pass.component';
import { CongresVirtuelLoginBackdoorComponent } from './congres-virtuel-login-backdoor/congres-virtuel-login-backdoor.component';
import { CongresVirtuelIndustrieComponent } from './congres-virtuel-industrie/congres-virtuel-industrie.component';
import { CongresVirtuelMentionsLegalesComponent } from './congres-virtuel-mentions-legales/congres-virtuel-mentions-legales.component';
import { CongresVirtuelComponent } from './congres-virtuel/congres-virtuel.component';
import { CongresWelcomeComponent } from './congres-welcome/congres-welcome.component';
import { CongresVirtuelConferencesComponent } from './congres-virtuel-conferences/congres-virtuel-conferences.component';
import { CongresVirtuelEpostersComponent } from './congres-virtuel-eposters/congres-virtuel-eposters.component';
import { CongresVisitingComponent } from './congres-visiting/congres-visiting.component';
import { HallOneComponent } from './hall-one/hall-one.component';
import { HallTwoComponent } from './hall-two/hall-two.component';
import { StandVisitingComponent } from './stand-visiting/stand-visiting.component';
import { CongresVirtuelManagerComponent } from './congres-virtuel-manager/congres-virtuel-manager.component';
import { CongresVirtuelManagerStandComponent } from './congres-virtuel-manager-stand/congres-virtuel-manager-stand.component';
import { SafePipe } from './pipes/safe.pipe';

import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';

//Must export the config
export const firebaseConfig = {
  apiKey: "AIzaSyAlgNX-kuDs1dOzsxXKlH5EP-hptcFDzBs",
  authDomain: "congres-smc.firebaseapp.com",
  databaseURL: "https://congres-smc.firebaseio.com",
  projectId: "congres-smc",
  storageBucket: "congres-smc.appspot.com",
  messagingSenderId: "916041439551",
  appId: "1:916041439551:web:b85e65b67560b155831b8a",
  measurementId: "G-2BZE6RQSZ9"
};

@NgModule({
  declarations: [
    AppComponent,
    CongresVirtuelMainComponent,
    CvmHeaderComponent,
    CvmFooterComponent,
    CvmLoginBoxComponent,
    CongresVirtuelVideoComponent,
    CongresVirtuelMotpresidentComponent,
    CongresVirtuelAproposComponent,
    CongresVirtuelAccreditationComponent,
    CongresVirtuelComitesComponent,
    CongresVirtuelAuthComponent,
    CongresVirtuelProgrammeComponent,
    CongresVirtuelChangePassComponent,
    CongresVirtuelLoginBackdoorComponent,
    CongresVirtuelIndustrieComponent,
    CongresVirtuelMentionsLegalesComponent,
    CongresVirtuelComponent,
    CongresWelcomeComponent,
    CongresVirtuelConferencesComponent,
    CongresVirtuelEpostersComponent,
    CongresVisitingComponent,
    HallOneComponent,
    HallTwoComponent,
    StandVisitingComponent,
    CongresVirtuelManagerComponent,
    CongresVirtuelManagerStandComponent,
    SafePipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    AngularFireModule,
    AngularFireDatabaseModule,
    AngularFireModule.initializeApp(firebaseConfig)
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
